import { Alert, Button, Drawer, LinkButton } from '@salecycle/ui-component-library';
import { useTranslation } from 'react-i18next';
import { useBranches } from '../../../state/Branches/hooks/useBranches';
import { useTheme } from 'styled-components';
import { Branches } from './components/Branches';
import { useAddNewBranch } from './hooks/useAddNewBranch';
import { useCallback } from 'react';
import { useIsAdditionalBranchesFlagEnabled } from './hooks/useIsAdditionalBranchesFlagEnabled';

export interface BranchControlDrawerProps {
  open: boolean;
  closeDrawer: () => void;
  messageId: string;
}

export function BranchControlDrawer({ messageId, open, closeDrawer }: BranchControlDrawerProps) {
  const { branches } = useBranches();
  const addNewBranch = useAddNewBranch();
  const isAdditionalBranchesEnabled = useIsAdditionalBranchesFlagEnabled();

  const addBranch = useCallback(() => {
    addNewBranch(messageId);
  }, [addNewBranch, messageId]);

  const { t } = useTranslation('campaigns');

  const theme = useTheme();

  return (
    <Drawer
      header={'Branch settings'}
      footer={
        <Button
          variation="secondary"
          onClick={closeDrawer}
          fullWidth
          ariaLabel={t('onsite.editor.workflow.branchControls.drawer.closeButtonAria')}
        >
          {t('onsite.editor.workflow.branchControls.drawer.closeButton')}
        </Button>
      }
      onClose={closeDrawer}
      open={open}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: theme.designToken.spacing4 }}>
        <Alert
          variant="info"
          heading="Your campaign audience will move from left to right across the branches, proceeding down the first branch where they match segmentation filters applied to branch messages."
        />
        <div>
          <div>Drag and drop your branches below to re-order them on the Workflow Canvas</div>
          <div style={{ marginBottom: theme.designToken.spacing3 }}></div>
          <Branches branches={branches} />
        </div>
        {isAdditionalBranchesEnabled ? (
          <LinkButton
            leftSideIcon="plus"
            onClick={addBranch}
            ariaLabel={t('onsite.editor.workflow.branchControls.addNewBranchAria')}
          >
            {t('onsite.editor.workflow.branchControls.addNewBranch')}
          </LinkButton>
        ) : null}
      </div>
    </Drawer>
  );
}
